import React, { useRef, useEffect } from "react";
import * as d3 from "d3";
import "./donut-chart.scss";
import Typography from "../../typography/typography";

interface DataPoint {
  label: string;
  value: number;
}

interface DonutChartProps {
  data: DataPoint[];
  width?: number;
  height?: number;
  legend?: boolean;
  direction?: "vertical" | "horizontal";
  total?: string;
  colors ?:Array<string>;
  titleProps?:any
  valueProps?:any 
  isUserDashbord ?: boolean 
  totalUsers ? : any 
}

const defaultColors = [
  "#5BCE97",
  "#B3D8E2",
  "#F5F6F5",
  "#AE6B9E",
  "#CBD49A",
  "#EEE0B3",
];

const getSingleNumberFromString = (str) => {
  if (typeof str === "number") {
    return str;
  }
  const match = str?.match(/\d.+/) || null;
  return match ? Number(match[0]) : 0;
};

export const DonutChart: React.FC<DonutChartProps> = ({
	data,
	height = 140,
	width = 140,
  isUserDashbord  , 
	legend = true,
	direction = 'horizontal' ,
  totalUsers ,  
	total =  isUserDashbord ? totalUsers : "2.4 GB",
  colors = defaultColors,
  titleProps={},
  valueProps={}, 

}) => {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (!svgRef.current) return;

    const svg = d3.select(svgRef.current);

    svg.selectAll("*").remove();

    const margin = 6;

    const outerRadius = Math.min(width, height) / 2 - margin;
    const innerRadius = Math.min(width, height) / 2 - margin * 2;

    const g = svg
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);
    //@ts-expect-error not applicable
    const pie = d3
      .pie()
      .value((d: DataPoint) => getSingleNumberFromString(d.value));

    const path = d3.arc().outerRadius(outerRadius).innerRadius(innerRadius);

    const pies = g
      .selectAll(".arc")
      //@ts-expect-error not applicable
      .data(pie(data))
      .enter()
      .append("g")
      .attr("class", "arc");

    pies
      .append("path")
      //@ts-expect-error not applicable
      .attr("d", path)
      //@ts-expect-error not applicable
      .attr("fill", (d: DataPoint, i: number) => {
        return colors[i % colors.length]});


    // const words = total.split(' '); // Split the text into words
    // const lineHeight = 22; // Define the line height
    // const maxCharsPerLine = 15; // Define the maximum number of characters per line

    // let currentLine = '';
    // let lineNumber = 0;

    // const textElement =
    g.append("text")
      .attr("text-anchor", "middle")
      .attr("font-size", "18px")
      .attr("font-weight", "600")
      .attr("alignment-baseline", `central`)
      .html(total);
    // .text(total);

    // words.forEach((word) => {
    // 	const tempLine = currentLine + word + ' ';

    // 	// Check if the line exceeds the max character count
    // 	if (tempLine.length > maxCharsPerLine && currentLine.length > 0) {
    // 		textElement
    // 			.append('tspan')
    // 			.attr('x', 0)
    // 			.attr('y', lineHeight * lineNumber)
    // 			.text(currentLine.trim());

    // 		currentLine = word + ' ';
    // 		lineNumber++;
    // 	} else {
    // 		currentLine = tempLine;
    // 	}
    // });

    // // Add the last line
    // textElement
    // 	.append('tspan')
    // 	.attr('x', 0)
    // 	.attr('y', lineHeight * lineNumber)
    // 	.text(currentLine.trim());
  }, [colors, data, height, total, width]);

  if (!legend) {
    return <svg ref={svgRef} width={width} height={height}></svg>;
  }

  return (
    <>
      <div className={`donut-chart-container ${direction}`}>
        <div>
          <svg ref={svgRef} width={width} height={height}></svg>
        </div>
        <div className="donut-chart-legend">
          {data && data.map((d: DataPoint, i: number) => {
            return (
              <div
                className="legend"
                key={d.label}
                style={{ borderLeft: `0.188rem solid ${colors[i]}` }}
              >
                <div className="legend-title">
                <Typography type="s5" color="theme.secondary.800" {...titleProps}>
                  {d.label}
                </Typography>
                  </div>
                <div className="legend-value">
                  <Typography
                    type="s5"
                    weight="medium"
                    color="theme.secondary.1000"
                  >
                    <Typography type="s5" color="theme.secondary.1000" weight="bold" {...valueProps}>
                      {d.value}
                    </Typography>
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default DonutChart;
